<template>
  <div
    v-if="isShowInterestForm"
    id="interestDemo"
    class="interest_demov2"
    data-stat-id="ly"
    data-stat-expose
  >
    <InterestForm
      :is-screen-capture-show="isScreenCaptureShow"
      :setting-store="settingStore"
      :interest-demo-options="interestDemoOptions"
      :init-interest-data="initInterestData"
      :form-data="curProductFormData"
      :params="{
        isForPresentation,
        uuid: params.uuid
      }"
      @open-add-and-take="onOpenAddAndTake"
      @update="update"
    />
    <!-- 概览、表格模块 -->
    <!-- 由于echart渲染原因，图表模块不能用v-show，需要用v-if -->
    <template v-for="o in DISPLAY_TYPE_OPTIONS">
      <component
        :is="`Interest${o.key}`"
        v-if="settingStore.displayType === o.key"
        :form-data="curProductFormData"
        :cur-product-interest-data="curProductInterestData"
        :interest-detail-with-remark="interestDetailWithRemark"
        :filter-interest-detail-data="filterInterestDetailData"
        :table-data="interestTableData"
        :params="{
          uuid: params.uuid,
          insuredAge: personData.insuredInfo.age,
          period: curProductPeriod
        }"
        :is-screen-capture-show="isScreenCaptureShow"
        @openExplain="isShowKeyExplain = true"
        @update="update"
      />
    </template>
    <InterestSettingPopups
      v-if="!URL_PARAM.noheader"
      ref="interestSettingPopups"
      :setting-store="settingStore"
      :form-data="curProductFormData"
      :interest-field-options="interestFieldOptions"
      :params="{
        isForPresentation,
        uuid: params.uuid,
        insuredAge: personData.insuredInfo.age
      }"
      @update-account-map="$emit('update-account-map', $event)"
      @update="update"
      @save="type => save(type)"
    />
    <InterestKeyExplain v-model="isShowKeyExplain" :filter-interest-detail-data="filterInterestDetailData" />
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import QS from 'qs'

import { initInterest, getInterestDetailWithRemark, saveShareInteraction, saveUserSettingByPlanbookId } from '@/pages/planbkTemplatev2/js/api.js'
import { isBxs } from 'base/config'
import { URL_PARAM } from '@/utils/variables.js'
import { initSettingStore, getBaofMultipleTag } from './handler.js'
import { DISPLAY_TYPE_OPTIONS } from './constant'

import InterestForm from './components/interest-form.vue'
import InterestOverview from './components/interest-overview.vue'
import InterestTable from './components/interest-table.vue'
import InterestSettingPopups from './components/interest-setting-popups.vue'
import InterestKeyExplain from './components/interest-key-explain.vue'

export default {
  components: {
    InterestForm,
    InterestOverview,
    InterestTable,
    InterestSettingPopups,
    InterestKeyExplain
  },
  props: {
    isForPresentation: Boolean,
    isScreenCaptureShow: Boolean,
    initResultData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    personData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      isApp: window.appBridge && window.appBridge.isApp(),
      isShowKeyExplain: false,
      settingStore: {
        displayType: '',
        activeProductId: null,
        productFormList: []
      },
      initInterestData: null,
      interestDetailData: null,
      interestDetailWithRemark: null,

      CACHE_DETAIL_DATA: {},
      DISPLAY_TYPE_OPTIONS,
      URL_PARAM
    }
  },
  computed: {
    isShowInterestForm () {
      return !!this.initInterestData && (this.initInterestData.length > 1 || !!(this.interestDetailData && this.interestDetailData.length))
    },
    resultData () {
      return this.initResultData.resultData
    },
    curProductFormData () {
      const { settingStore } = this
      const { activeProductId, productFormList } = settingStore
      return productFormList.find(p => p.productId === activeProductId) || productFormList[0]
    },
    curProductResultData () {
      const { resultData, settingStore } = this
      const productGroup = resultData && resultData.productGroupList[0]
      const prodOrderList = productGroup && productGroup.prodOrderList
      const product = prodOrderList && prodOrderList.find(p => p.key === settingStore.activeProductId)
      return product
    },
    curProductPeriod () {
      const { curProductResultData } = this
      if (!curProductResultData) {
        return 0
      }
      const firstInsurance = curProductResultData.mulInsOrderList.find(ins => ins.key !== 'common')
      if (firstInsurance) {
        return firstInsurance.period
      }
      return 0
    },
    curProductInterestData () {
      return this.initInterestData && this.initInterestData.find(e => e.productId === this.settingStore.activeProductId)
    },
    filterInterestDetailData () {
      const { interestDetailData, curProductFormData } = this
      const { displayFields } = curProductFormData.formValues
      if (!interestDetailData) {
        return []
      }
      return interestDetailData.filter(item => displayFields.includes(item.key))
    },
    interestTableData () {
      const { personData, curProductFormData, curProductResultData, curProductInterestData, curProductPeriod, filterInterestDetailData : values, interestFieldOptions, interestDetailWithRemark } = this
      if (!values || !curProductInterestData) {
        return []
      }
      const age = _get(personData, 'insuredInfo.age')
      const period = _get(personData, 'main.period') || curProductPeriod

      const tableDataHeader = {
        year: '年度',
        age: '年龄'
      }
      values.forEach(value => {
        tableDataHeader[value.key] = `<em>${value.name}</em>` + (value.detail ? '<i class="iconfont icon-common_problem"></i>' : '')
      })
      const { startPolicyNo, startIndex } = curProductInterestData
      const maxlength = values.reduce((a, b) => Math.max(a, b.values.length || 0), 0);
      let tableData = []
      values.filter(e => e.values).forEach((item) => {
        for (let i = 0; i < maxlength; i++) {
          tableData[i] = tableData[i] || {
            year: i + startPolicyNo,
            age: i + age + startIndex  + 1,
          }
          tableData[i][item.key] = item.values[i]
          if (['take', 'draw_value'].includes(item.key) && item.details && item.details.length) {
            tableData[i][`__${item.key}_purpose__tag`] = item.details[i] || ''
          }
        }
      })
      tableData = getBaofMultipleTag(tableData)

      const displayAge = curProductFormData.formValues.displayAge
      if (displayAge) {
        tableData = tableData.filter((e, i, arr) => (i === 0) || (i === arr.length - 1) || (e.year <= period) || ((e.age % displayAge) === 0))
      }

      tableData.unshift(tableDataHeader)
      this.$store.commit('SET_INTEREST_DATA', {
        curProductInterestData,
        curProductResultData,
        curProductFormData,
        interestFieldOptions,
        interestDetailWithRemark,
        interestTableData: tableData,
      })
      return tableData
    },
    interestDemoOptions () {
      const { isApp, isForPresentation, initInterestData, settingStore, curProductResultData, curProductFormData, curProductInterestData } = this
      const isInAppEditable = isApp && !isForPresentation
      if (!curProductFormData) {
        return
      }
      const formItems = []
      if (_get(initInterestData, 'length') > 1) {
        formItems.push({
          key: 'activeProductId',
          stat: 'lycpqh',
          name: '产品',
          options: initInterestData.map(d => ({
            description: d.productName,
            value: d.productId
          }))
        })
      }

      const _mulInsOrderList = _get(curProductResultData, 'mulInsOrderList') || []
      const _resultAddAndTakeIns = _mulInsOrderList.find(ins => ins.account && ins.accountData && ins.accountData.accountPart)
      const _resultReduceBaofIns = _mulInsOrderList.find(ins => ins.reduceBaof)
      if (_resultAddAndTakeIns) {
        const _accountPart = _get(_resultAddAndTakeIns, 'accountData.accountPart')
        const name = {
          addAndTake: '追加领取',
          add: '追加',
          take: '领取'
        }[_accountPart]
        const _addAndTakeData = _get(curProductFormData, 'addAndTakeData.addAndTakeData') || []
        const hasAddAndTake = _addAndTakeData.some(ele => ele.adjustData && ele.adjustData.length)
        if (isInAppEditable || hasAddAndTake) {
          formItems.push({
            key: 'addAndTakeData',
            stat: 'lyzjlqqh',
            name,
            options: hasAddAndTake ? [
              { description: '追加/领取前', value: false },
              { description: '追加/领取后', value: true }
            ] : [],
            actionBtnTx: isInAppEditable ? `设置${name}` : ''
          })
        }
      }
      if (_resultReduceBaofIns) {
        const _drawData = _get(curProductFormData, 'drawData') || []
        const hasDraw = _drawData.some(ele => ele.adjustData && ele.adjustData.length)
        if (isInAppEditable || hasDraw) {
          formItems.push({
            key: 'drawData',
            stat: 'lyzjlqqh',
            name: '减保',
            options: hasDraw ? [
              { description: '减保前', value: false },
              { description: '减保后', value: true }
            ] : [],
            actionBtnTx: isInAppEditable ? '设置减保领取' : ''
          })
        }
      }

      initInterestData
        .filter(e => settingStore.activeProductId === e.productId)
        .forEach((interest) => {
          if (interest.bonus) {
            formItems.push({
              key: 'bonus',
              stat: 'lyfhqh',
              name: '分红',
              options: interest.bonus.opts
            })
          }
          const _takeTypeOptsLength = (_get(interest, 'takeType.opts') || []).filter(o => !o.hiddenFlag).length
          if (_takeTypeOptsLength > 1) {
            formItems.push({
              key: 'takeType',
              stat: 'lqfs',
              name: '当年领取',
              options: _get(interest, 'takeType.opts')
            })
          }
          if (interest.rate) {
            const options = cloneDeep(interest.rate.opts).map((o, i) => ({
              ...o,
              index: i
            }))
            let customRateOption = false
            if (options && options.length) {
              options.forEach((o, i) => {
                // 服务端逻辑（By ZXY）：账户利益选项是依次：保证、中档、高档、假定利率。即 3 一定是对应假定利率
                if (i === 3) {
                  o.value = curProductFormData.customRate || o.value
                }
                o.description = `${o.description} ${(o.value * 100).toFixed(2)}%`;
                if (o.description.search(/\$/) !== -1) {
                  o.description = `${o.description.replace('$', '')}`;
                }
              })
              customRateOption = options.find(o => o.index === 3)
              if (customRateOption) {
                // 当假定利率的值已存在，隐藏假定利率选项。From hyw
                customRateOption.hiddenFlag = options.filter(e => e.value === customRateOption.value).length > 1
              }
            }
            const _accountRateHistoryList = _get(curProductInterestData, 'accountRateHistoryList') || []
            const actionBtnTx = customRateOption ? '设置利率' : (_accountRateHistoryList && _accountRateHistoryList.length) ? '历史利率' : ''
            formItems.push({
              key: 'rate',
              stat: 'lyllqh',
              name: '账户利率',
              hasCustomRate: !!customRateOption,
              actionBtnTx,
              options
            })
          }
        })
      return ['activeProductId', 'bonus', 'drawData', 'takeType', 'rate', 'addAndTakeData'].map(k => formItems.find(e => e.key === k)).filter(e => !!e)
    },
    interestFieldOptions () {
      const { interestDetailData, interestDemoOptions } = this
      if (!interestDetailData) {
        return []
      }
      const formItems = interestDemoOptions.filter(e => e.key !== 'activeProductId')
      formItems.push({
        key: 'displayAge',
        stat: 'lyxsxsxhsxx',
        name: '展示年龄',
        options: [
          { value: null, description: '全部' },
          { value: 5, description: '5岁的倍数' },
          { value: 10, description: '10岁的倍数'},
        ]
      })
      formItems.push({
        key: 'displayFields',
        stat: 'lyxsxsxzdxx',
        name: '保单利益（选择转发后可见的展示项目-多选）',
        options: interestDetailData.map(v => ({
          value: v.key,
          description: v.name
        }))
      })
      return formItems
    }
  },
  async created () {
    const self = this
    await self.initInterest()
    if (location.hash === '#interestDemo') {
      setTimeout(() => {
        const interestDemo = document.querySelector(location.hash)
        if (interestDemo) {
          interestDemo.scrollIntoView()
        }
      }, 2000)
    }
  },
  methods: {
    initInterest () {
      const { initResultData, params } = this
      return initInterest({
        uuid: params.uuid
      }).then((res) => {
        const { success, data } = res.data
        if (!(success && data && data.length)) {
          this.$emit('set-interest-key', [])
          return
        }
        this.settingStore = initSettingStore(data, initResultData)
        this.initInterestData = data
        this.getInterestDetail()
        this.$emit('set-interest-key', this.getInterestKey(data))
      }).catch(() => {
        this.$emit('set-interest-key', [])
      })
    },
    getInterestKey (data) {
      let keys = []
      data.forEach(pd => {
        if (!Array.isArray(pd.data)) return
        pd.data.forEach(({ key }) => {
          if (keys.indexOf(key) < 0) keys.push(key)
        })
      })
      return keys
    },
    async getInterestDetail () {
      const self = this
      const { params, settingStore, curProductFormData, CACHE_DETAIL_DATA } = self
      const { drawInsuranceId, accountInsuranceId, customRate, addAndTakeData, drawData, formValues } = curProductFormData
      const { bonus, takeType, rate, rateIndex, drawFlag, addAndTakeFlag, hideFieldsForClient } = formValues
      const reqParams = {
        uuid: params.uuid,
        productId: settingStore.activeProductId,
        drawInsuranceId,
        accountInsuranceId,
        bonus: {
          value: bonus
        },
        takeType: {
          value: takeType
        },
        rate: {
          value: rateIndex === -1 ? customRate : rate
        },
        addAndTakeData: addAndTakeData ? addAndTakeData.addAndTakeData : null,
        addAndTakeFlag,
        drawData,
        drawFlag
      }
      const cacheKey = QS.stringify(reqParams)
      if (CACHE_DETAIL_DATA[cacheKey]) {
        self.interestDetailData = CACHE_DETAIL_DATA[cacheKey]
      } else {
        self.interestDetailData = await getInterestDetailWithRemark(reqParams).then((res) => {
          const { success, data, info } = res.data
          if (!(success && data)) {
            this.$toast(info || '接口异常')
            return Promise.reject()
          }
          if (data.dataList) {
            data.dataList.forEach(d => {
              if (['irr_value', 'single_value', 'policy_cash_grow_rate'].includes(d.key)) {
                return
              }
              if (d.values) {
                d.values = d.values.map(v => v ? Math.round(v) : v)
              }
            })
          }
          self.interestDetailWithRemark = data
          CACHE_DETAIL_DATA[cacheKey] = data.dataList
          return Promise.resolve(data.dataList)
        })
      }

      self.interestDetailData = self.interestDetailData.filter(e => isBxs || !(hideFieldsForClient && hideFieldsForClient.includes(e.key)))

      // 过滤详情中没有的字段。From hyw
      // 没有默认字段，默认选中所有。From hyw
      // add、take、take_sum、add_sum 字段，只要详情中有，默认选中。From hyw
      formValues.displayFields = formValues.displayFields.filter(k => self.interestDetailData.some(e => e.key === k))
      if (!(formValues.displayFields && formValues.displayFields.length)) {
        formValues.displayFields = self.interestDetailData.map(e => e.key)
      }
      const fileds = ['take', 'add', 'take_sum', 'add_sum', 'draw_value', 'draw_sum']
      fileds.forEach(k => {
        if (!formValues.displayFields.includes(k) && self.interestDetailData.find(e => e.key === k)) {
          formValues.displayFields.push(k)
        }
      })
    },
    update (data = {}) {
      const { settingStore } = this
      let isNeedSendRequest = false
      Object.keys(data).forEach(k => {
        if (Object.keys(settingStore).includes(k)) {
          settingStore[k] = data[k]
        }
        const currentProduct = settingStore.productFormList.find(p => p.productId === settingStore.activeProductId)
        if (Object.keys(currentProduct).includes(k)) {
          currentProduct[k] = data[k]
        } else if (Object.keys(currentProduct.formValues).includes(k)) {
          currentProduct.formValues[k] = data[k]
        }

        if (!['displayType', 'displayFields', 'displayAge', 'hideFieldsForClient'].includes(k)) {
          isNeedSendRequest = true
        }
      })
      if (isNeedSendRequest) {
        this.getInterestDetail()
      }
      if (this.syncDelta) {
        this.syncDelta({ pbData: { interestDemoV2Setting: data } })
      }
    },
    save (type = 0) {
      // type： 0-按resultUuid存配置 1-按planbookId存配置
      const { params, resultData, settingStore } = this
      const cpStore = cloneDeep(settingStore)
      if (cpStore.productFormList) {
        cpStore.productFormList.forEach(p => {
          if (p.addAndTakeData) {
            p.addAndTakeData = p.addAndTakeData.addAndTakeData
          }
          // 不再保存自定义利率、设置浮层的状态。From hyw
          if (p.formValues) {
            p.formValues.isShowFieldPopup = false
            p.formValues.isShowRatePopup = false
          }
        })
      }
      if (type === 1) {
        return saveUserSettingByPlanbookId(_get(resultData, 'insuranceTypeId'), cpStore)
      }
      return saveShareInteraction({
        resultUuid: params.uuid,
        interestSetting: cpStore
      }).then(res => {
        const { success, data } = res.data
        if (!success || !data) {
          return Promise.resolve()
        }
        return Promise.resolve(data)
      })
    },
    onOpenAddAndTake (item) {
      const interestSettingPopupsComp = this.$refs.interestSettingPopups
      if (interestSettingPopupsComp && typeof interestSettingPopupsComp.openAddAndTakePicker === 'function') {
        interestSettingPopupsComp.openAddAndTakePicker(item)
      }
    }
  }
}
</script>
<style>
@import './index.css';
</style>
